import { AyudaActionTypes, SET_AYUDA } from "../types/ayudaActionTypes";


export const initialAyuda: any = {
"":""
};

export function ayudaReducer(state = initialAyuda, action: AyudaActionTypes): any {
    switch (action.type) {
        case SET_AYUDA:
            return action.ayuda;
        default:
            return state;
    }
}
